import type { RootState } from '~features';

const selectAllProjects = (state: RootState) => state.projectsList.all;

const selectAllProjectsIsLoading = (state: RootState) => state.projectsList.isLoading;

const selectAllProjectsError = (state: RootState) => state.projectsList.error;

export { selectAllProjects, selectAllProjectsError, selectAllProjectsIsLoading };
